import { useCallback, useState } from "react";

const readStoredPosition = (sliderKey, defaultPosition) => {
  const stored = localStorage.getItem(sliderKey);

  if (stored === null) {
    return defaultPosition;
  }

  const parsed = Number(stored);

  return Number.isNaN(parsed) ? defaultPosition : parsed;
};

const useSliderPosition = (sliderKey, defaultPosition = 0) => {
  const [position, setPositionState] = useState(() =>
    readStoredPosition(sliderKey, defaultPosition),
  );

  const setPosition = useCallback(
    next => {
      localStorage.setItem(sliderKey, String(next));
      setPositionState(next);
    },
    [sliderKey],
  );

  return [position, setPosition];
};

export default useSliderPosition;
